// extracted by mini-css-extract-plugin
export default {"Card":"archivedUserCard_Card__dmiEQ","ArchivedUserCard":"archivedUserCard_ArchivedUserCard__GaCVa"};